import {useEffect, useState} from "react";
import API from "../../../API";
import style from '../task-creator.module.css'

export function Tags({changeTags, defaultValue=null,setAllTags}) {
    const api = new API()
    const [filters,setFilters]=useState({})
    const [tags,setTags]=useState(defaultValue||[])

    useEffect(()=>{
        api.getFilters().then(data=>{
            setFilters(data)
            setAllTags(data)
        })
        if(defaultValue){
            setTags(defaultValue)
        }
    },[])

    useEffect(() => {
        changeTags(tags)
    }, [tags])

    function onChange(e){
        let tag = {
            name: e.target[e.target.selectedIndex].text,
            id: Number(e.target.value)
        }
        let isInclude = false;
        tags.forEach(item=>{
           if(tag.id === item.id){
               isInclude=true
               return;
           }
        })
        if(!isInclude) {
            setTags(prev => [...prev, tag])
        }
    }
    function deleteTag(tagId){
        let newTags = tags.filter(item =>item.id!==tagId)
        setTags(newTags)
    }
    const fields =[];
    for(let tagsName in filters){
        const options =[];
        options.push(<option disabled key={tagsName+1}  value={0}>{tagsName}</option>)
        filters[tagsName].forEach(tag=>{
                options.push(<option value={tag.id} key={tagsName + tag.name}>{tag.name}</option>)
        })
       fields.push(
           <select className={style.task_tag_select} defaultValue={0} onChange={e => onChange(e)} key={tagsName}>
                {options}
           </select>
        )
    }

  return(
      <div className={`${style.task_dark} ${style.task_line_box}`}>
          <div>
          {fields}
          {tags && <div>{tags.map(item=><div onClick={()=>deleteTag(item.id)} key={item.id}>{item.name}</div>)}</div>}
          </div>
      </div>

  )


}